import React, { useEffect, useContext, useState } from "react";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import PropTypes from "prop-types";
import { allCountries } from "@/config";
import t from "Utils/translation";
import Button from "Components/button/Button";
import sessionStore from "@/stores/session";
import { MediaQueriesContext } from "@/App";
import SupportContactBox from "Components/supportContactBox/SupportContactBox";
import InputPhone from "Components/inputPhone/InputPhone";

import cx from "classnames";
// import s from "./orderForm.scss";

const OriginStep = (props) => {
  const [countriesOptions, setCountriesOptions] = useState([]);

  useEffect(() => {
    props.resetOrdersState();

    setCountriesOptions(
      allCountries.map((c) => {
        return {
          value: c.value,
          label: sessionStore.language === "it" ? c.ita_label : c.label,
        };
      }),
    );
  }, []);

  const goToNextStep = () => {
    props.goToStep(2);
  };

  const changeCountry = (val) => {
    if (val.country !== "IT") {
      props.setFormFieldValue({ customer_type: "company" });
    }
    props.setFormFieldValue(val);
  };

  const {
    formData: { country },
  } = props;

  const { isMediaMobile, isMediaSM, isMediaMD } = useContext(MediaQueriesContext);

  return (
    <div className="orderPage">
      {props.stepper}

      {!isMediaMobile && !isMediaSM && !isMediaMD && <SupportContactBox className="supportBox" />}

      <div className={cx("sectionTitle", "titleFP")}>{t("order.add.title.step1")}</div>

      <div className="wrapScrollFP">
        <div className="infoFP">
          <div className="sectionDesc">{t("order.add.desc.step1")}</div>
        </div>

        <div className="wrapFormsFP">
          <div className="formsFP">
            <Select
              className="inputFull2"
              label={t("input.label.select.country")}
              components={{ DropdownIndicator }}
              name="country"
              options={countriesOptions}
              onChange={changeCountry}
              clearable={false}
              value={country}
            />
          </div>
          <div className="footerFP">
            <Button color="text" type="button" onClick={props.backToList}>
              button.cancel
            </Button>
            <Button color="accent" onClick={goToNextStep}>
              button.continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OriginStep;
